export default __webpack_public_path__ + "static/media/screen-mobile.1d740d1d.svg";